/**
 * @file 语音合成服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {pick, range} from 'lodash';

export default class AudioServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';
    serviceType = 'audio';

    formData = {
        appId: '',
        name: '',
        lan: 'MANDARIN',
        speed: '5',
        intonation: '5',
        volume: '5',
        timbre: 'MAN',
        text: '',
        submitType: null
    };

    audioDemo = null;

    appListDatasource = [];
    languageDatasource = Object.freeze(this.getConstantDatasource('LAN'));
    timbreDatasource = Object.freeze(this.getConstantDatasource('TIMBRE'));
    speakSpeedDatasource = Object.freeze(range(0, 10).map(i => ({label: i, value: i})));
    volumeDatasource = Object.freeze(range(0, 16).map(i => ({label: i, value: i})));

    init() {
        super.init();

        this.demoRequester = this.api.appServiceAudioDemo;
    }

    adaptData(data) {
        data = super.adaptData(data);
        return {
            ...data,
            ...pick(
                this.serviceDetail.data,
                ['lan', 'speed', 'intonation', 'volume', 'timbre', 'text']
            )
        };
    }

    async reuqestDemo() {
        this.audioDemo = await this.demoRequester(
            pick(
                this.formData,
                ['lan', 'speed', 'intonation', 'volume', 'timbre', 'text']
            )
        );
    }

}
